import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a2f2e8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "grid",
  id: "taskGrid"
}
const _hoisted_2 = { class: "flex align-center" }

import WideCard from "@/components/global/WideCard.vue";

import Card from "@/components/global/Card.vue";
import TaskConfiguration from "@/model/Tasks/TaskConfiguration";
import Database from "@/model/Database";
import * as Lang from "@/i18n/lang";
import * as ModuleManager from "@/firebase/ModuleManager";
import { getStoreTaskConfigurationState } from "@/pinia/tasks/StoreTaskConfigurationState";
import { getDatabaseTaskConfigurationState } from "@/pinia/tasks/DatabaseTaskConfigurationState";

import { getState } from "@/pinia/NavigationState";
import DatabaseTaskConfiguration from "@/model/Tasks/DatabaseTaskConfiguration";
import { defineComponent } from "vue";
import TaskModuleConfigurationAction from "@/model/Tasks/config/TaskModuleConfigurationAction";
import TaskModuleConfigurationTemperature from "@/model/Tasks/config/TaskModuleConfigurationTemperature";

const __default__ = defineComponent({
  props: ["tasks", "database", "store", "storeDatabase", "unactives"],

  data() {
    return { ModuleManager: ModuleManager, Lang: Lang };
  },

  methods: {
    isAutomatic(task: TaskConfiguration) {
      if (task.configuration) {

        var tempTask = task.configuration as TaskModuleConfigurationTemperature;

        if (tempTask) {
          return tempTask.automatic;
        }
      }
      return false;
    },

    onTaskClick(task: TaskConfiguration) {
      if (this.storeDatabase) {
        getStoreTaskConfigurationState().set(task, this.store);
        getState().navigate("storeTaskConf");
      } else {
        getDatabaseTaskConfigurationState().set(
          <DatabaseTaskConfiguration>task,
          this.database
        );
        getState().navigate("taskConf");
      }
    },
  },
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TaskConfigurationList',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_SeImage = _resolveComponent("SeImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: task.id
      }, [
        (task.getActive() || _ctx.unactives)
          ? (_openBlock(), _createBlock(WideCard, {
              key: 0,
              active: task.getActive() == undefined ? false : task.getActive(),
              icon: "/ico/task.svg",
              title: task.getName(),
              click: () => _ctx.onTaskClick(task)
            }, {
              subtitle: _withCtx(() => [
                _createTextVNode(_toDisplayString(Lang.getI18N(ModuleManager.getModuleFromRef(task.getModule())?.key!)), 1)
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _withDirectives(_createVNode(_component_Badge, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Auto")
                    ]),
                    _: 2
                  }, 1536), [
                    [_vShow, _ctx.isAutomatic(task)]
                  ]),
                  (task.notify_late)
                    ? (_openBlock(), _createBlock(_component_SeImage, {
                        key: 0,
                        class: "tooltip",
                        maxWidth: 20,
                        maxHeight: 20,
                        style: {"filter":"grayscale(100%)"},
                        src: "ico/support-blue.svg"
                      }))
                    : _createCommentVNode("", true),
                  (task.isLocal())
                    ? (_openBlock(), _createBlock(_component_SeImage, {
                        key: 1,
                        class: "tooltip",
                        maxWidth: 20,
                        maxHeight: 20,
                        style: {"filter":"grayscale(100%)"},
                        src: "ico/store.svg"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["active", "title", "click"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})